import Step2Content from './Step2Content';

export default Step2Content;
